$(function(){
    var dataTable = null;
    var cloudHistory = null;
    
    function reloadLicenseData(cleanup){
        $.displayLoadingIndicator(loadingText);
        
        if (cleanup === null) {
            $('.main-contents').hide();  
            $('.pagination-controls').hide();
        }
        
        getTableData(cleanup);
    }
    
    function showCleanupDialog(){
    	var cleanupDialogID = '#cleanupDialog';
    	var buttonID = '#clearHistory';
    	
    	$(cleanupDialogID).dialog({
            width: 400,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
            	"OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    tabindex : 0,
                    click : function() {
                        $.animateCloseDialog(cleanupDialogID, buttonID);
                        reloadLicenseData($('input[name="history"]:checked').val());
                    }
            	},
            	"Cancel" : {
                    text : cancelButtonText,
                    tabindex : 0,
                    click : function() {
                        $.animateCloseDialog(cleanupDialogID, buttonID);
                    }
                }
            },
            open: function() {
                $.animateOpenDialog(cleanupDialogID, buttonID);
            }
    	});
    }
    
    function getLicenseData(cleanup) {
    	var url = 'ws/Licenses/history';
    	if(!!cleanup){
    		url += '?clean=' + cleanup;
    	}
    	return  $.ajax({
            url : url,
            data : {},
            dataType: 'json',
            async : true,
            cache : false
    	});
    }
    	
    
	function getTableData(cleanup) {
        var tableSorting = [4, 'desc'];
        var displayRecords = 10;
        
        $.when(
            getLicenseData(cleanup)
        ).done(function(response) {
        	$.debugLog(response);
        	var success = response.LicenseHistoryList.success;
        	var licenseList = response.LicenseHistoryList.licenses;
        	
            if (!!licenseList && !$.isArray(licenseList)) {
                licenseList = [licenseList];
            }

        	$.debugLog("License History Table Data: ");
        	$.debugLog(licenseList);
        	
        	if (success) {
        		if (!!dataTable) {
        			dataTable.fnClearTable();
        			
        			if (!!licenseList) {
        			    dataTable.fnAddData(licenseList);
        			}
        		} else {
	                dataTable = $('#licenseTable').dataTable({
	                    bProcessing: false,
	                    bAutoWidth : false,
	                    aaData: licenseList,
	                    aoColumns: [
                            {
                                mData : 'customerName',
                                visible : !!cloudHistory,
                                sDefaultContent : ''
                            },
                            {
                                mData : 'siteId',
                                visible : !!cloudHistory,
                                className : 'right-align-cell',
                                sDefaultContent : ''
                            },
                            {
                                mData : 'userName',
                                visible : !cloudHistory,
                                className : 'no-caps',
                                sDefaultContent : ''
                            },
	                        {
	                            mData : 'uid',
	                            sDefaultContent : '',
                                className : 'no-caps'
	                        },
	                        {
	                            mData : 'timestamp',
	                            className : 'right-align-cell',
	                            sDefaultContent : ''
	                        },
	                        {
	                        	mData : 'fullProductName',
	                        	sDefaultContent : ''
	                        },
	                        {
	                            mData : 'event',
	                            className : 'event-column',
	                            sDefaultContent : ''
	                        },
	                        {
	                            mData : 'errorText',
	                            sDefaultContent : '',
	                            className : 'history-status',
	                            mRender : function(data){
	                            	if(!!data){
	                            		return "Failure: " + data;
	                            	} else {
	                            		return "Success"
	                            	}
	                            }
	                        },
	                        {
	                            mData : 'licensesUsed',
	                            className : 'right-align-cell',
	                            sDefaultContent : ''
	                        },
	                        {	
	                            mData : 'licensesTotal',
	                            className : 'right-align-cell',
	                            sDefaultContent : ''
	                        }
	                    ],
	                    "fnCreatedRow": function ( nRow, aData ) {
	                    	if( !!aData.errorText ) {
	                    		$(nRow).addClass('error');
	                    	}
	                    },
	                    "aaSorting" : tableSorting,
	                    "bPaginate" : true,
	                    "sPaginationType" : "full_numbers",
	                    "iDisplayLength" : displayRecords, 
	                    "bLengthChange" : true,
	                    "sDom" : 'RtB<"#licenseRowCount"l><"#licensePagination"p>',
	                    "buttons" : [{extend : 'csvHtml5', exportOptions: {columns: ':visible'}}],
	                    "oLanguage" : {
	                        "oPaginate" : {
	                            "sFirst" : firstPaginationText,
	                            "sPrevious" : previousPaginationText,
	                            "sNext" : nextPaginationText,
	                            "sLast" : lastPaginationText
	                        },
	                        "sLengthMenu": showLabelText + '<select>' +
	                        '<option value="10">' + count10Text + '</option>' +
	                        '<option value="25">' + count25Text + '</option>' +
	                        '<option value="50">' + count50Text + '</option>' +
	                        '<option value="100">' + count100Text + '</option>' +
	                        '<option value="500">' + count500Text + '</option>' +
	                        '<option value="-1">' + countAllText + '</option>' +
	                        '</select>' + entriesLabelText
	                    },
	                    "fnInitComplete" : function() {
	                        // Position the pagination controls
	                        var rowCountWidget = $('#licenseRowCount');
	                        rowCountWidget.addClass('row-count');
	                        rowCountWidget.appendTo('#paginationControls');
	                        
	                        var paginationWidget = $('#licensePagination');
	                        paginationWidget.addClass('pagination');
	                        paginationWidget.appendTo('#paginationControls');
	                    }
	                });
        		}
        	} else {
        		$.removeLoadingIndicator();
                $.showMessageDialog({
                    dialogID : '#errorMsgDialog',
                    title    : licenseErrorTitle,
                    message  : response.message 
                });
        	}
        	
        	TERMIT = false;
        }).always(function() {
            $.removeLoadingIndicator();
            $('.main-contents').show();
            $('.pagination-controls').show();
        });
	}
	
	function exportCSV(){
		$('.buttons-csv').click();
	}
    
    $(document).ready(function() {
        cloudHistory = getQuery('cloud');
        
        if (!!cloudHistory) {
            $('.cloud-column').removeClass('hidden');
        }
        
        $.getJSON('database/list', {
            requestType: 'list', 
            nocache: new Date().getTime()
        }, function(data) {
            // Did we get a successful return?
            if (data.success) {
            	$('#clearHistory').on('click', showCleanupDialog);
            	$('#exportCSV').on('click', exportCSV)
                
                reloadLicenseData(null);
            } else {
                var mainContents = $('.main-contents');
                mainContents.addClass('no-db');
                mainContents.html(noDatabaseText);
            }
        });
    });
});